export const FETCH_USER_SIGNUP_REQUEST = 'FETCH_USER_SIGNUP_REQUEST';
export const FETCH_USER_SIGNUP_SUCCESS = 'FETCH_USER_SIGNUP_SUCCESS';
export const FETCH_USER_SIGNUP_FAILURE = 'FETCH_USER_SIGNUP_FAILURE';

export const FETCH_USER_VERIFICATION_CODE_REQUEST = 'FETCH_USER_VERIFICATION_CODE_REQUEST';
export const FETCH_USER_VERIFICATION_CODE_SUCCESS = 'FETCH_USER_VERIFICATION_CODE_SUCCESS';
export const FETCH_USER_VERIFICATION_CODE_FAILURE = 'FETCH_USER_VERIFICATION_CODE_FAILURE';
export const RESET_USER_VERIFICATION_CODE_STATE = 'RESET_USER_VERIFICATION_CODE_STATE';

export const FETCH_USER_LOGIN_REQUEST = 'FETCH_USER_LOGIN_REQUEST';
export const FETCH_USER_LOGIN_SUCCESS = 'FETCH_USER_LOGIN_SUCCESS';
export const FETCH_USER_LOGIN_FAILURE = 'FETCH_USER_LOGIN_FAILURE';

export const FETCH_USER_SOCIAL_LOGIN_REQUEST = 'FETCH_USER_SOCIAL_LOGIN_REQUEST';
export const FETCH_USER_SOCIAL_LOGIN_SUCCESS = 'FETCH_USER_SOCIAL_LOGIN_SUCCESS';
export const FETCH_USER_SOCIAL_LOGIN_FAILURE = 'FETCH_USER_SOCIAL_LOGIN_FAILURE';
